<template>
  <div class="ma-0 pa-0">
    <v-btn v-bind="$attrs"
           :loading="loading"
           :class="apiButtonClass"
           @click="handleClick"
           v-on="$listeners">
      <slot />
    </v-btn>

    <confirm-dialog v-if="confirmRequired"
                    v-model="showConfirmDialog"
                    :title="confirmTitle"
                    :message="confirmMessage"
                    :confirm-color="confirmColor"
                    :loading="loading"
                    @confirm="onConfirm"
                    @cancel="onCancel" />
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  name: 'ApiBtn',
  components: {ConfirmDialog},
  props: {
    apiUrl: {
      type: [String, Array],
      default: undefined,
    },
    apiMethod: {
      type: String,
      default: 'post',
    },
    apiData: {
      type: [Object, Array],
      default: undefined,
    },
    successMessage: {
      type: String,
      default: undefined,
    },
    successMessageColor: {
      type: String,
      default: 'success',
    },
    preApiCallCallback: {
      type: Function,
      default: undefined,
    },
    confirmRequired: {
      type: Boolean,
      default: false,
    },
    confirmTitle: {
      type: String,
      default: '',
    },
    confirmMessage: {
      type: String,
      default: '',
    },
    confirmColor: {
      type: String,
      default: 'error',
    },
    noRightPadding: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['success', 'error', 'preApiCall'],
  data () {
    return {
      loading: false,
      showConfirmDialog: false,
    };
  },
  computed: {
    apiButtonClass () {
      return this.noRightPadding ? 'rounded-lg base-height col pr-0' : 'rounded-lg base-height col';
    },
  },
  methods: {
    async submit () {
      await this.executeApiCall();
    },
    handleClick () {
      if (this.confirmRequired) {
        this.showConfirmDialog = true;
      } else {
        this.executeApiCall();
      }
    },
    onConfirm () {
      this.executeApiCall();
    },
    onCancel () {
      this.showConfirmDialog = false;
    },
    async executeApiCall (depth = 0) {
      let retry    = false;
      this.loading = true;
      this.$emit('preApiCall');
      if (typeof this.preApiCallCallback !== 'undefined' && !await this.preApiCallCallback()) {
        this.loading = false;
        return;
      }
      try {
        const success = await this.API[this.apiMethod](this.apiUrl, this.apiData);
        if (success.status === 202) {
          if (depth <= 3) {
            retry = true;
            await this.$store.dispatch('snackbar/add', {
              color: 'warning',
              content: 'apiErrors[\'' + success.data.message + '\']',
              timeout: 4500,
            });
            setTimeout(() => {
              this.executeApiCall(depth + 1);
            }, 5000);
          } else {
            await this.$store.dispatch('snackbar/add', {
              color: 'warning',
              content: 'apiErrors[\'Your request taking to much time, try refreshing page later.\']',
              timeout: 4500,
            });
            this.$emit('error');
          }
        } else {
          this.$emit('success', success.data);
          if (this.successMessage) {
            await this.$store.dispatch('snackbar/add', {
              color: this.successMessageColor, content: this.successMessage,
            });
          }
          if (this.deleteMessage) {
            await this.$store.dispatch('snackbar/add', {
              color: this.successMessageColor, content: this.successMessage,
            });
          }
        }
      } catch (e) {
        this.$emit('error', e);
      } finally {
        if (!retry) {
          this.loading = false;
          this.showConfirmDialog = false;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.base-height
  min-height: 36px
</style>
